/* eslint-disable */
import { auth } from '@/plugins/auth/firebase.js'
import Cookie from 'js-cookie'
import JWTDecode from 'jwt-decode'

export const subscriptions = {
    namespaced: true,
    state: {
        subscriptions_list: [],
        currentItem: {},
        isLoading: false,
        selectedPlan: {},
        subscriptionDialog:false
    },

    mutations: {

        SET_SUBSCRIPTIONS_LIST (state, payload) {
            state.subscriptions_list = payload
        },
        SET_LOADING (state, payload) {
            state.isLoading = payload
        },
        SET_CURRENT_ITEM (state, payload) {
            state.currentItem = payload
        },
        SET_SELECTED_PLAN (state, payload) {
          state.selectedPlan = payload
        },
        SET_SUBSCRIPTION_DIALOG (state, payload) {
          state.subscriptionDialog = payload
        }
    },

    actions: {
        async loadItems ({ commit, state, rootState }, type) {
             return new Promise((resolve, reject) => {
                commit('SET_LOADING', true)
                let userId = ''
                if(rootState.users.user.adminUid){
                    userId = rootState.users.user.adminUid
                }else{
                    userId = rootState.users.user.uid
                }
                // console.log(userId)
                let path
                let loadCommit
                switch (type) {
                    case 'subscriptions':
                        path = `users/${userId}/subscriptions`
                        loadCommit = 'SET_SUBSCRIPTIONS_LIST'
                    break
                }

                // console.log(loadCommit)

                // console.log(path)
                 firebase.database().ref(path).orderByChild('name').on('value',
                    function (snapshot) {
                        // console.log(snapshot.val())
                        commit('SET_LOADING', false)
                        commit(loadCommit, snapshot.val())
                        resolve()
                    }, function (error) {
                        console.error(error)
                        commit('SET_LOADING', false)
                        reject()
                    },
                )
            })
        },
        async setSubscriptionDialog({ commit }, payload){
          const setCommit = 'SET_SUBSCRIPTION_DIALOG'
          await commit(setCommit, payload)
        },
        async selectPlan({ commit, state, rootState }, payload){
          const setCommit = 'SET_SELECTED_PLAN'
          await commit(setCommit, payload)
        },
        setCurrentItem ({ commit, state, rootState }, payload) {
            // commit('SET_LOADING', true);
            const vm = this
            let userId = ''
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            if (payload) {
                return new Promise((resolve, reject) => {
                const path = `users/${userId}/subscriptions`
                const setCommit = 'SET_CURRENT_ITEM'
                let id

                try {
                    const currentItem = state.subscriptions_list.find(item => item.id === payload.id)
                    // console.log(currentItem)
                    if (!payload.id) {
                        id = currentItem.id
                    } else {
                        id = payload.id
                    }
                    const dbRef = firebase.database().ref()
                    let item
                    dbRef.child(path + '/' + id).on('value', function (data) {
                        // console.log(data.val(), id)
                        item = {
                            ...data.val(),
                            id: data.key,
                        }
                        commit(setCommit, item)
                        // commit('setLoading', false);
                        resolve()
                    }, function (error) {
                        // console.log(error)
                        // commit('setLoading', false);
                        reject()
                    })
                } catch (err) {
                    reject()
                    // console.log(err)
                }
            })
            } else {
                commit('SET_CURRENT_ITEM', {})
            }
        },

    },
    getters: {
        getItems (state) {
            return state.subscriptions_list
        },
        getCurrentItem (state) {
            return state.currentItem
        },
    },

}
